<template>
  <div v-show="!this.collapsed" class="info__collapsed">
    <q-btn size="sm" padding="xs" color="primary" @click="this.toggleCollapsed">
      <q-tooltip>Раскрыть</q-tooltip>
      <q-icon name="fas fa-arrow-left" class="collapseIcon" />
    </q-btn>
  </div>

  <q-drawer
    :width="this.drawerWidth"
    show-if-above
    :behavior="this.behavior"
    @update:model-value="toggleCollapsed"
    :model-value="this.collapsed"
    side="right"
  >
    <div v-show="this.collapsed" class="info">
      <LegendLoading v-if="this.isFetching" />
      <NotFoundText v-if="!this.info?.data?.length" />
      <div
        v-if="!this.isFetching && !this.info?.data?.length"
        style="padding: 0 10px;"
      >
        <q-btn
          size="sm"
          padding="xs"
          color="primary"
          @click="this.toggleCollapsed"
        >
          <q-tooltip>Скрыть</q-tooltip>
          <q-icon name="fas fa-arrow-right" class="collapseIcon" />
        </q-btn>

        <div class="info__empty">
          <q-btn
            size="sm"
            padding="xs"
            color="green"
            @click="() => reloadData && reloadData()"
          >
            Получить данные
            <q-icon name="replay" class="reloadIcon" />
          </q-btn>
        </div>
      </div>
      <div v-if="!this.isFetching" class="info__items">
        <div
          class="info__item"
          v-if="!!this.info?.data?.length"
          style="display: flex; justify-content: space-between;"
        >
          <div style="display: flex; gap: 10px; justify-content: space-between; width: 100%;">
            <div style="display: flex; gap: 10px;">
              <q-btn
              size="sm"
              padding="xs"
              color="primary"
              @click="this.toggleCollapsed"
            >
              <q-tooltip>Скрыть</q-tooltip>
              <q-icon name="fas fa-arrow-right" class="collapseIcon" />
            </q-btn>
            <q-btn
              size="sm"
              padding="xs"
              color="green"
              @click="() => reloadData && reloadData()"
            >
              <q-tooltip>Обновить</q-tooltip>
              <q-icon name="replay" class="reloadIcon" />
            </q-btn>
            </div>
            
            <div
              class="info__empty tw-flex tw-gap-2 tw-justify-end"
              style="text-align: right;"
            >
              <q-icon
                name="account_tree"
                size="18px"
                class="tw-text-grey-7"
              />
              <span style="font-weight: 500;">{{
                this.isOldSchema ? 'Старая схема приёмки' : 'Новая схема приёмки'
              }}</span>
            </div>
          </div>

          <q-btn
            v-if="!!this.info?.is_defect_exist"
            color="red"
            size="xs"
            :dense="true"
            padding="xs"
            style="width: fit-content; letter-spacing: 1px;"
            :loading="this.pointsData.fetchingAllPoints"
            @click="this.pointsData.getData(null, this.pointsData?.params ? !this.pointsData.params.placement_type_id : false)"
          >
            <q-icon
              :name="(this.pointsData?.params && !this.pointsData.params.placement_type_id) ? 'close' : 'warning'"
            />
            <q-tooltip
              >{{`${(this.pointsData?.params && !this.pointsData.params.placement_type_id) ? 'Скрыть' : 'Показать'} замечания`}}</q-tooltip
            >
          </q-btn>
        </div>

        <q-list>
          <q-expansion-item
            v-for="type in this.info?.data"
            :key="type.placement_type_id"
            v-model="expansionPlacementType[type.placement_type_id]"
            :class="['custom-expansion', 'custom-expansion__parent']"
            expand-icon="keyboard_arrow_down"
            expand-icon-class="custom-expand-icon"
            header-class="custom-expansion__header"
            header-style="min-height: 40px"
          >
            <template v-slot:header>
              <q-item-section
                style="font-weight: 500;"
                >{{ `${type.placement_type_name} — ${formatPrice(type.total_sum)} ₸ (${type.placement_percent}%)` }}</q-item-section
              >
              <q-item-section
                style="font-weight: 500;"
                v-if="type.placement_okk_status_colours?.length"
              >
                <div
                  style="display: flex; align-items: center; flex-wrap: wrap; gap: 5px; justify-content: flex-end;"
                >
                  <q-btn
                    v-if="!!type.is_defect_exist"
                    color="red"
                    size="xs"
                    :dense="true"
                    padding="xs"
                    style="width: fit-content; letter-spacing: 1px;"
                    @click.stop="this.pointsData.getData({placement_type_id: type.placement_type_id}, this.pointsData?.params?.placement_type_id && this.pointsData.params?.placement_type_id === type.placement_type_id && !this.pointsData.params.work_set_check_group_id)"
                  >
                    <q-icon
                      :name="(this.pointsData?.params?.placement_type_id && this.pointsData.params?.placement_type_id === type.placement_type_id && !this.pointsData.params.work_set_check_group_id) ? 'close' : 'warning'"
                    />
                    <q-tooltip
                      >{{`${(this.pointsData?.params?.placement_type_id && this.pointsData.params?.placement_type_id === type.placement_type_id && !this.pointsData.params.work_set_check_group_id) ? 'Скрыть' : 'Показать'} замечания`}}</q-tooltip
                    >
                  </q-btn>
                  <q-icon
                    v-for="iconColor in type.placement_okk_status_colours"
                    name="flag"
                    :color="iconColor || 'red'"
                    :style="`font-size: 18px; color: ${iconColor || '#000'};`"
                  />
                </div>
              </q-item-section>
            </template>
            <q-list class="child">
              <q-expansion-item
                v-for="group in type.work_set_check_groups"
                :key="group.work_set_check_group_id"
                v-model="expansionCheckGroup[`${type.placement_type_id}_${group.work_set_check_group_id}`]"
                :label="`${group.work_set_check_group_name} — ${formatPrice(group.total_sum)} ₸`"
                class="custom-expansion"
                expand-icon="keyboard_arrow_down"
                header-style="min-height: 40px; background-color: rgb(229, 229, 229);"
                expand-icon-class="custom-expand-icon"
              >
                <template v-slot:header>
                  <q-item-section
                    style="font-weight: 500;"
                    >{{ `${group.work_set_check_group_name} — ${formatPrice(group.total_sum)} ₸` }}</q-item-section
                  >
                  <q-item-section
                    style="display: flex; align-items: center; gap: 5px; flex-wrap: wrap;"
                  >
                    <q-btn
                      v-if="!!group.is_defect_exist"
                      color="red"
                      size="xs"
                      :dense="true"
                      padding="xs"
                      style="width: fit-content; letter-spacing: 1px;"
                      :loading="this.pointsData.fetchingPoints[type.placement_type_id + '_' + group.work_set_check_group_id]"
                      @click.stop="this.pointsData.getData({placement_type_id: type.placement_type_id, work_set_check_group_id: group.work_set_check_group_id}, !!this.pointsData.params?.work_set_check_group_id && group.work_set_check_group_id === this.pointsData.params?.work_set_check_group_id)"
                    >
                      <q-icon
                        :name="(!!this.pointsData.params?.work_set_check_group_id && group.work_set_check_group_id === this.pointsData.params?.work_set_check_group_id) ? 'close' : 'warning'"
                      />
                      <q-tooltip
                        >{{`${(!!this.pointsData.params?.work_set_check_group_id && group.work_set_check_group_id === this.pointsData.params?.work_set_check_group_id) ? 'Скрыть' : 'Показать'} замечания`}}</q-tooltip
                      >
                    </q-btn>
                    <div
                      style="display: inline-flex; align-items: center; gap: 6px; flex-wrap: wrap; justify-content: center"
                    >
                      <q-btn
                        v-if="this.showCallBtn(group)"
                        color="primary"
                        size="xs"
                        :dense="true"
                        :disable="group.to_disable || (!group.is_geodesist_call && !group.usp_done)"
                        padding="xs"
                        class="call-okk-btn"
                        style="width: fit-content; letter-spacing: 1px;"
                        :loading="!!this.okkLoading[group.work_set_check_group_id + '_' + type.placement_type_id]"
                        @click.stop="this.onCallOKKClick(type.placement_type_id, group.work_set_check_group_id, group.work_sets, group.is_geodesist_call)"
                      >
                        {{ group.is_geodesist_call ? 'Вызов геодезиста' : this.isOldSchema ? 'Вызов ИТР' : 'Запустить процесс приёмки' }}
                        <q-tooltip v-if="!group.is_geodesist_call && !group.usp_done">Оперфакт должен быть 100%, заполните Оперфакт</q-tooltip>
                      </q-btn>
                      <q-btn
                        v-if="!this.isOldSchema && !!group.current_node_labels?.length"
                        color="blue-grey"
                        size="md"
                        :dense="true"
                        padding="xs"
                        flat
                        style="width: fit-content;"
                        @click.stop="openBpmnModal(type.placement_type_id, group.work_set_check_group_id)"
                      >
                        📋
                        <q-tooltip>Схема процесса приёмки</q-tooltip>
                      </q-btn>
                    </div>
                    <q-btn
                      v-if="this.isOldSchema && !!group.help_call_id"
                      color="negative"
                      size="xs"
                      :dense="true"
                      padding="xs"
                      style="width: fit-content; letter-spacing: 1px;"
                      :loading="!!this.deleteCallLoading[group.help_call_id]"
                      @click.stop="this.onDeleteCallClick(group.help_call_id)"
                    >
                      Удалить вызов
                    </q-btn>
                    <div
                        v-if="!this.isOldSchema && group.current_node_labels?.length"
                        class="tw-font-semibold info__item_status"
                        :style="`background-color: #ffc534`"
                        style="color: #404040;"
                      >
                        📍 {{ group.current_node_labels.join(' · ') }}
                        <q-tooltip>Текущие шаги схемы приёмки</q-tooltip>
                    </div>
                    <div
                      v-else-if="this.isOldSchema && !!group.checked_status"
                      :style="`background-color: ${group.checked_status_colour}`"
                      class="info__item_status"
                    >
                      {{group.checked_status}}
                    </div>
                    <div
                      v-if="this.isOldSchema && group.is_foreman_checked === 1"
                      class="info__item_foremanStatus"
                    >
                      Принято начальником участка
                    </div>
                  </q-item-section>
                </template>
                <q-list class="q-ml-md">
                  <q-item
                    v-for="set in group.work_sets"
                    :key="set.work_set_id"
                    style="min-height: 35px;"
                  >
                    <q-item-section>
                      <span
                        :class="['info__item_text', {info__item_textSelectable: !!this.selectable}, {info__item_textSelected: this.selected === set.work_set_id}]"
                        @click="() => this.onSelect && this.onSelect(set.work_set_id)"
                      >
                        <i
                          >{{ `${set.work_set_name} ${set.unit_name ? `(${set.work_set_amount || ''} ${set.unit_name})` : ''}`  }}</i
                        ></span
                      >
                    </q-item-section>
                    <q-item-section side>
                      <span
                        v-if="set.fact_pct != null"
                        class="tw-text-xs tw-font-medium"
                        :style="{ color: set.fact_pct >= 100 ? '#16a34a' : '#f97316' }"
                      >
                        {{ set.fact_pct }}%
                        <q-tooltip>Процент выполнения в Оперфакте</q-tooltip>
                      </span>
                      {{ formatPrice(set.total_sum) }} ₸
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-expansion-item>
            </q-list>
          </q-expansion-item>
        </q-list>
      </div>
    </div>
  </q-drawer>

  <q-dialog v-model="showNewTaskDialog">
    <q-card class="work-sets-okkerr-dialog" style="min-width: 300px; max-width: 480px">
      <q-card-section>
        <div class="text-h6">Новая задача!</div>
      </q-card-section>
      <q-card-section class="q-pt-none">
        <div class="work-sets-okkerr-dialog__message tw-whitespace-pre-wrap">
          {{ 'У вас появилась новая задача, выполните ее' }}
        </div>
      </q-card-section>
      <q-separator />
      <q-card-actions
        class="q-pa-md"
        align="right"
        style="flex-wrap: wrap; gap: 8px; justify-content: flex-end"
      >
        <q-btn flat no-caps label="Закрыть" v-close-popup />
        <q-btn
          :color="'primary'"
          no-caps
          label="Мои задачи"
          @click="goToEmployeeTasks"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>

  
  <BpmnProcessModal
    v-if="bpmnModal"
    :work-set-check-group-id="bpmnModal.workSetCheckGroupId"
    :floor-map-id="bpmnModal.floorMapId"
    :placement-type-id="bpmnModal.placementTypeId"
    @close="bpmnModal = null"
  />
</template>

<script>
import LegendLoading from "./LegendLoading.vue";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import {
  callOKK,
  deleteOKKCall,
  workStatuses,
  getFloorMapAcceptanceCode,
  checkCertificates
} from "./services";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import { useAppStore } from "@/services/store/app";
import { MODAL_NAMES } from "@/constants";
import { mapState } from 'pinia';
import BpmnProcessModal from "@/views/WorkCheckBpmn/BpmnProcessModal.vue";

export default {
  name: "FloorWorkSets",
  components: {LegendLoading, CustomCheckbox, BpmnProcessModal},
  props: [
    'info',
    'onChange',
    'isFetching',
    'selectable',
    'onSelect',
    'selected',
    'collapsed',
    'reloadData',
    'floorMapId',
    'pointsData',
    'projectId',
    'documentParams',
  ],
  data() {
    return {
      workStatuses,
      workSetLoading: false,
      drawerWidth: window.innerWidth < 576 ? window.innerWidth : 470,
      behavior: window.innerWidth < 991 ? 'mobile' : 'desktop',
      okkLoading: {},
      deleteCallLoading: {},
      showNewTaskDialog: false,
      bpmnModal: null,
      isOldSchema: false,
      expansionPlacementType: {},
      expansionCheckGroup: {},
    }
  },
  methods: {
    async checkIsOldSchema() {
      const code = await getFloorMapAcceptanceCode(this.floorMapId);
      this.isOldSchema = code === 'OLD'
    },
    showCallBtn(group) {
      const call = group.checked_status_code !== 'DONE' && group.checked_status_code !== 'PROCESSING' && group.checked_status_code !== 'GEODESIST'
      if (this.isOldSchema) return call
      return !group.current_node_labels?.length
    },
    goToEmployeeTasks() {
      this.showNewTaskDialog = false
      window.open("/employee-tasks", "_blank")
    },
    toggleCollapsed() {
      this.$emit('toggleCollapsed')
    },
    formatPrice(value) {
      return new Intl.NumberFormat("ru-RU", {
        maximumFractionDigits: 0
      }).format(value)
    },
    openBpmnModal(placementTypeId, workSetCheckGroupId) {
      this.bpmnModal = {
        workSetCheckGroupId,
        floorMapId: this.floorMapId,
        placementTypeId,
      }
    },
    async onCallOKKClick(
      placement_type_id,
      work_set_check_group_id,
      work_sets = null,
      is_geodesist_call = false,
    ) {
      if (this.isOldSchema) {
        const loadingKey = work_set_check_group_id + '_' + placement_type_id
        this.okkLoading[loadingKey] = true
        const needSelectDate = this.userData?.is_select_call_date
        const url = typeof window !== 'undefined' ? window.location.href : ''
        let certificates = []
        try {
          certificates = await checkCertificates({
            project_id: this.projectId,
            work_set_check_group_id,
            url,
          }) || []
        } finally {
          this.okkLoading[loadingKey] = false
        }
        const hasCertificates = Array.isArray(certificates) && certificates.length > 0

        if (needSelectDate || hasCertificates) {
          this.showModal(MODAL_NAMES.SelectDate, {
            title: is_geodesist_call ? "Дата вызова геодезиста" : "Дата вызова ОКК",
            showCalendar: needSelectDate,
            certificates: certificates,
            projectId: this.projectId,
            onConfirm: async (date) => {
              await this.callGroupOKK(placement_type_id, work_set_check_group_id, date)
            },
          })
          return
        }
      }
      this.callGroupOKK(placement_type_id, work_set_check_group_id, work_sets)
    },
    async callGroupOKK(placement_type_id, work_set_check_group_id, work_sets = null) {
      const loadingKey = work_set_check_group_id + '_' + placement_type_id
      this.okkLoading[loadingKey] = true
      const body = {
        placement_type_id,
        work_set_check_group_id,
      }
      const res = await callOKK(this.floorMapId, body)
      this.okkLoading[loadingKey] = false
      if (!res) return
      
      this.onChange && this.onChange(res)
      if (this.reloadData) this.reloadData()
      this.showSucceedSnackbar()
      if (this.isOldSchema) {
        this.closeModal()
        return
      }
      this.showNewTaskDialog = true
    },
    onDeleteCallClick(help_call_id) {
      if (!help_call_id) return
      this.showModal(MODAL_NAMES.CONFIRM, {
        title: "Удалить вызов?",
        btnText: "Удалить",
        cancelBtnText: "Отмена",
        onSubmit: async () => {
          await this.deleteCall(help_call_id)
        },
      })
    },
    async deleteCall(help_call_id) {
      if (!help_call_id) return
      this.deleteCallLoading[help_call_id] = true
      const body = {
        help_call_id,
        floor_map_id: this.floorMapId,
      }
      const res = await deleteOKKCall(body)
      this.deleteCallLoading[help_call_id] = false
      if(!res) return
      this.onChange && this.onChange(res)
      this.closeModal()
      this.showSucceedSnackbar()
    }
  },
  computed: {
    ...mapState(useAppStore, ['userData']),
  },
  mounted() {
    this.checkIsOldSchema()
  },
  setup() {
    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar()
    const appStore = useAppStore()
    const { showModal, closeModal } = appStore
    return { showSucceedSnackbar, showErrorSnackbar, showModal, closeModal }
  }
};
</script>

<style scoped lang="scss">

.info {
  width: 470px;
  height: calc(100vh - 50px);
  overflow-y: auto;
  border-left: 1px solid #e5e5e5;
  padding: 10px 0;
  background-color: rgb(255, 255, 255);
  transition: all .4s;

  @media (max-width: 576px) {
    width: 100%;
    height: 100%;
  }

  &__collapsed {
    position: absolute;
    top: 10px;
    right: 15px;
    transition: all .4s;
  }

  &__items {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  &__empty {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}
.info__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;

  &_content {
    display: flex;
    align-items: center;
    font-size: 13px;
    line-height: 1.25;
  }

  &_text {
    i {
      font-style: normal;
      font-weight: 400;
      color: #2c2c2c;
    }

    &Selectable {
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    &Selected {
      color: #1264d7;
      text-decoration: underline;
      i {
        color: #1264d7;
      }
    }
  }
  &_count {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    border-top: 1px solid #dfdfdf;
    padding-top: 5px;
    margin-top: 5px;
  }
  &_status {
    padding: 3px 5px;
    border-radius: 4px;
    font-size: 13px;
    line-height: 12px;
    text-align: center;
  }
  &_foremanStatus {
    font-size: 11px;
    color: #4f4f4f;
    line-height: 12px;
  }
}
.custom-expansion {
  font-size: 12px;
  padding: 0;
  font-weight: 400;
  min-height: 40px !important;
  margin-top: 5px;
  &__header {
    padding: 5px 15px;
  }
}
.custom-expansion__header {
  padding: 5px 15px;
}
.custom-expansion__parent {
  font-size: 13px;
  font-weight: 600;
}
.custom-expand-icon {
  font-size: 14px;
}
.child {
  padding-left: 16px;
}

.call-okk-btn {
  &.disabled {
    opacity: 0.5!important;
    cursor: not-allowed!important;
    background-color: #444!important;
  }
}
</style>
